import { successHandler } from '../../../utils/handlers';

const onDownloadClick = () => {
  successHandler({
    message: {
      message:
        'Reports generation job is in progress. You will receive an email with downloadable link on your email',
      title: 'Success',
    },
  });
};

export default onDownloadClick;
